<template>
  <div class="">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :error.sync="error" :finished="finished" :immediate-check="false" class="p-l-20 p-r-20 p-b-20" finished-text="没有更多了" @load="getList">
        <div v-for="(item,index) in list" :key="index" class="bg-FF p-20 m-t-20">
          <div class="flex col-center row-between">
            <div class="flex-1 ellipsis-1 font-30 cor-3E3A39 font-weight-500 m-l-10 ">
              {{ item.reportName }}
            </div>
            <div class="font-26 cor-F8B91A p-l-20 p-r-10 p-b-6 p-t-6" @click="viewFile_1(item)">预览</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import {getTicket} from '@/api/file.js';
import * as ww from '@wecom/jssdk'
import {getRemoteData} from "@/api/flow";
import mixin from "@/mixin/flow";

export default {
  mixins: [mixin],
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      fileUrl: null,
      fileSize: null,
      fileName: null,
      corpId: 'ww5b7b6b536dc90edd',
      jsSdkApiArr: ['previewFile', 'getLocation'],
      remark: null
    }
  },
  created() {
    if (this.$route.query) {
      this.remark = this.$route.query.remark
      if (this.$route.query.remark != 'third') { // 自建
        this.registerWw(this.corpId, this.jsSdkApiArr).then(() => {
          console.log('registerWw completed, calling filePreview');
          this.filePreview()
          this.getList()
        }).catch((error) => {
          console.error('registerWw failed:', error);
          // 即使注册失败也尝试预览文件
          this.filePreview();
          this.getList()
        });
        this.fileUrl = this.$route.query.url
        this.fileSize = this.$route.query.fileSize
        this.fileName = this.$route.query.fileName
      } else {
        // this.fileUrl = this.$route.query.url + '?corpid=' + localStorage.getItem('corpid')
        // this.fileSize = this.$route.query.fileSize
        // this.fileName = this.$route.query.fileName
        //
        // this.wwRegister(window.encodeURIComponent(location.href.split('#')[0]), ww => {
        //   ww.previewFile({
        //     url: this.fileUrl,
        //     name: this.fileName,
        //     size: this.fileSize
        //   })
        //   this.getList()
        // })

        this.fileUrl = this.$route.query.url + '?corpid=' + this.corpId
        this.fileSize = this.$route.query.fileSize
        this.fileName = this.$route.query.fileName

        this.registerWw(this.corpId, this.jsSdkApiArr).then(() => {
          console.log('registerWw completed, calling filePreview');
          this.filePreview()
          this.getList()
        }).catch((error) => {
          console.error('registerWw failed:', error);
          // 即使注册失败也尝试预览文件
          this.filePreview();
          this.getList()
        });
      }
    }
  },
  methods: {
    registerWw(corpId, jsSdkArr) {
      return new Promise((resolve, reject) => {
        getTicket().then(res => {
          ww.register({
            corpId: corpId,
            jsApiList: jsSdkArr,
            getConfigSignature() {
              return ww.getSignature(res.ticket)
            }
          })
          resolve();
        }).catch(e => {
          console.error('后台获取ticket数据失败:', e)
          reject(e);
        });
      });
    },
    filePreview() {
      let that = this
      ww.previewFile({
        url: that.fileUrl,
        name: that.fileName,
        size: that.fileSize
      })
    },
    viewFile_1(item) {
      // 将字符串 URL 转换为 URL 对象
      const urlObj = new URL(item.reportUrl);
      // 提取查询参数
      const fileSize = urlObj.searchParams.get('fileSize')
      const fileUrl = urlObj.searchParams.get('url')
      let url = this.remark == 'third' ? fileUrl + '?corpid=' + this.corpId : fileUrl
        ww.previewFile({
          url: url,
          name: item.reportPath,
          size: fileSize,
        })
    },
    getList() {
      this.loading = true;
      getRemoteData('/system/reportlog/list', 'get', this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        this.list = this.list.concat(res.rows)
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;

        if (res.total == this.list.length) {
          this.finished = true
        }
      }).catch(err => {
        this.error = true
      })
    },
    // 下拉刷新
    onRefresh() {
      this.finished = false;
      this.list = []
      this.queryParams.pageNum = 1
      this.getList();
    }
  }
}
</script>
<style lang="less" scoped>
</style>
